<div (blur)="onTouched()" class="multiselect-dropdown" (clickOutside)="closeDropdown()" *ngIf="!_settings.accessible; else accessibleMultiSelect">
  <div [class.disabled]="disabled">
    <span tabindex="0" class="dropdown-btn" #main (keypress)="toggleDropdown($event)" (click)="toggleDropdown($event)">
      <span *ngIf="selectedItems.length == 0">{{_placeholder}}</span>
      <span class="selected-item" tabindex="0" *ngFor="let item of selectedItems;trackBy: trackByFn;let k = index" [hidden]="k > _settings.itemsShowLimit-1">
        {{item.text}} <span *ngIf="!!item.categoriaText" class="item-categoria-grouped">{{item.categoriaText}}</span>
        <a tabindex="0" class="closing-tag-btn" [attr.aria-label]="'Elimina' + item.text" style="padding-top:2px;padding-left:2px;color:white" (keydown)="onItemDeleteKeydown($event,item)" (click)="onItemClick($event,item)">x</a>
      </span>
      <span style="float:right !important;padding-right:4px">
        <span style="padding-right: 6px;" *ngIf="itemShowRemaining()>0">+{{itemShowRemaining()}}</span>
        <span [ngClass]="_settings.defaultOpen ? 'dropdown-up' : 'dropdown-down'"></span>
      </span>
    </span>
  </div>
  <div class="dropdown-list" [hidden]="!_settings.defaultOpen">
    <ul class="item1">
      <li (click)="toggleSelectAll()" *ngIf="(_data.length > 0 || _settings.allowRemoteDataSearch) && !_settings.singleSelection && _settings.enableCheckAll && _settings.limitSelection===-1" class="multiselect-item-checkbox" style="border-bottom: 1px solid #ccc;padding:10px">
        <input type="checkbox" (focus)="onElementFocused($event)" (keydown.enter)="$event.preventDefault()" (keydown.escape)="onEsc()" [attr.aria-label]="!isAllItemsSelected() ? _settings.selectAllText : _settings.unSelectAllText" [checked]="isAllItemsSelected()" [disabled]="disabled || isLimitSelectionReached()" />
        <div>{{!isAllItemsSelected() ? _settings.selectAllText : _settings.unSelectAllText}}</div>
      </li>
      <li class="filter-textbox" *ngIf="(_data.length>0 || _settings.allowRemoteDataSearch) && _settings.allowSearchFilter">
        <input *ngIf="automaticSearch" type="text" (keydown.enter)="$event.preventDefault()" [attr.aria-label]="_placeholder" [readOnly]="disabled" [placeholder]="_settings.searchPlaceholderText" [(ngModel)]="filter.text" (ngModelChange)="onFilterTextChange($event)">
        <div *ngIf="!automaticSearch" class="search-wrapper">
            <input 
              (keydown.escape)="onEsc()"
              (keydown.enter)="$event.preventDefault()"
              type="text"
              class="search-input"
              [attr.aria-label]="_placeholder"
              [readOnly]="disabled"
              [placeholder]="_settings.searchPlaceholderText"
              [(ngModel)]="filter.text">
            <button 
              type="button" 
              class="search-button"
              (click)="onFilterTextChange(filter.text)"
              aria-label="Cerca">
              <svg class="search-icon" viewBox="0 0 24 24">
                <path fill="currentColor" 
                  d="M9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.61-.59 3.09-1.57 
                    4.23l4.92 4.92-1.41 1.41-4.92-4.92A6.48 6.48 0 0 1 
                    9.5 16 6.5 6.5 0 1 1 9.5 3zm0 2A4.5 4.5 0 1 0 
                    9.5 14a4.5 4.5 0 0 0 0-9z"/>
              </svg>
            </button>
        </div>





      </li>
    </ul>
    <ul class="item2" #dropdownList *ngIf="!grouped; else groupings" [style.maxHeight]="_settings.maxHeight+'px'">
      <li *ngFor="let item of _data | multiSelectFilter:filter; let i = index;" (click)="onItemClick($event,item)" class="multiselect-item-checkbox">
        <input type="checkbox" (focus)="onElementFocused($event)" (keydown.enter)="$event.preventDefault()" (keydown.escape)="onEsc()" [attr.aria-label]="item.text" [checked]="isSelected(item)" [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item.isDisabled" />
        <div>{{item.text}}</div>
      </li>
      <li class='no-data' *ngIf="_data.length == 0 && !_settings.allowRemoteDataSearch">
        <h5>{{_settings.noDataAvailablePlaceholderText}}</h5>
      </li>
    </ul>
    <ng-template #groupings>
      <ul class="item2" [style.maxHeight]="_settings.maxHeight+'px'">
         <li *ngFor="let element of categories">
          <div  class="title-category"> {{ (groupedData[element.key]?.length > 0) ? element.value : 'Nessuna ' + element.value.toLowerCase() }}</div>
          <ul>
            <li *ngFor="let item of groupedData[element.key]; let i = index;" (click)="onItemClick($event,item)" class="multiselect-item-checkbox">
              <input type="checkbox" (focus)="onElementFocused($event)" (keydown.enter)="$event.preventDefault()" (keydown.escape)="onEsc()" [attr.id]="item.text + i" [attr.aria-label]="item.text + 'categoria' + element.value" [checked]="isSelected(item)" [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item.isDisabled" />
              <div>{{item.text}}</div>
              <label [attr.for]="item.text + i" class="sr-only">{{item.text}}</label>
            </li>
            <li class='no-data' *ngIf="_data.length == 0 && !_settings.allowRemoteDataSearch">
              <h5>{{_settings.noDataAvailablePlaceholderText}}</h5>
            </li>
          </ul>
         </li>
      </ul>
    </ng-template>
  </div>
</div>

<!-- CONFIGURAZIONE PER ACCESSIBILITà -->

<ng-template #accessibleMultiSelect>
  <div #multiselectArea>
    <div class="col-sm-7" style="padding-left: unset !important;">
      <div style="display: flex; align-items: baseline;">
        <div class="col-sm-12" style="padding: unset !important;">
          <div class="dropdown-list" style="position: relative; z-index: 0; margin: unset; box-shadow: unset;">
            <ul class="item1">
              <li class="filter-textbox" *ngIf="(_data.length>0 || _settings.allowRemoteDataSearch) && _settings.allowSearchFilter" style="padding: unset !important;">
                <input 
                  type="text" 
                  [attr.id]="getRandomId()"
                  [attr.aria-label]="_settings.searchPlaceholderText" 
                  [readOnly]="disabled" 
                  class="multiselect-search-input form-control"
                  [placeholder]="_settings.searchPlaceholderText" 
                  [(ngModel)]="filter.text" 
                  (focusin)="onInputFocusIn($event)"
                  (focusout)="onInputFocusOut($event)" 
                  (ngModelChange)="onFilterTextChange($event)">
              </li>
            </ul>
            <div *ngIf="_settings.accessibileDefaultOpen">
              <ul class="item2" *ngIf="!grouped; else groupings" [style.maxHeight]="_settings.maxHeight+'px'">
                <li (click)="toggleSelectAll()" *ngIf="(_data.length > 0 || _settings.allowRemoteDataSearch) && !_settings.singleSelection && _settings.enableCheckAll && _settings.limitSelection===-1" class="multiselect-item-checkbox" style="border-bottom: 1px solid #ccc;padding:10px">
                  <input type="checkbox" (focus)="onElementFocused($event)" (keydown.enter)="$event.preventDefault()" (keydown.escape)="onEsc()" [attr.aria-label]="!isAllItemsSelected() ? _settings.selectAllText : _settings.unSelectAllText" [checked]="isAllItemsSelected()" [disabled]="disabled || isLimitSelectionReached()" />
                  <div>{{!isAllItemsSelected() ? _settings.selectAllText : _settings.unSelectAllText}}</div>
                </li>
                <li *ngFor="let item of _data | multiSelectFilter:filter; let i = index;" (click)="onItemClick($event,item)" class="multiselect-item-checkbox">
                  <input type="checkbox" (focus)="onElementFocused($event)" (keydown.enter)="$event.preventDefault()" (keydown.escape)="onEsc()" class="selectable" [attr.aria-label]="item.text" [checked]="isSelected(item)" [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item.isDisabled" />
                  <div>{{item.text}}</div>
                </li>
                <li class='no-data' *ngIf="_data.length == 0 && !_settings.allowRemoteDataSearch">
                  <h5>{{_settings.noDataAvailablePlaceholderText}}</h5>
                </li>
              </ul>
              <ng-template #groupings>
                <ul class="item2" [style.maxHeight]="_settings.maxHeight+'px'">
                   <li *ngFor="let element of categories">
                    <div  class="title-category"> {{ (groupedData[element.key]?.length > 0) ? element.value : 'Nessuna ' + element.value.toLowerCase() }}</div>
                    <ul>
                      <li *ngFor="let item of groupedData[element.key]; let i = index;" (click)="onItemClick($event,item)" class="multiselect-item-checkbox">
                        <input type="checkbox" (focus)="onElementFocused($event)" (keydown.enter)="$event.preventDefault()" (keydown.escape)="onEsc()" class="selectable" [attr.id]="item.text + i" [attr.aria-label]="item.text + 'categoria' + element.value + ' ' + selectedItems.length + ' elementi selezionati'" [checked]="isSelected(item)" [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item.isDisabled" />
                        <div>{{item.text}}</div>
                        <label [attr.for]="item.text + i" class="sr-only">{{item.text}}</label>
                      </li>
                      <li class='no-data' *ngIf="_data.length == 0 && !_settings.allowRemoteDataSearch">
                        <h5>{{_settings.noDataAvailablePlaceholderText}}</h5>
                      </li>
                    </ul>
                   </li>
                </ul>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="col-sm-2" *ngIf="_settings.searchButton">
          <button type="button" aria-label="Cerca" class="btn btn-primary btn-block search-btn" (click)="onSearchFilter()">Cerca</button>
        </div>
      </div>
    </div>
    <div class="col-sm-3">
      <div [class.disabled]="disabled" style="display: flex; flex-direction: column;">
        <span>
          <label *ngIf="selectedItems.length > 0" 
            aria-live="assertive" 
            aria-atomic="true" 
            [tooltip]="selectedItems.length + ' Element' + (selectedItems.length > 1 ? 'i' : 'o') + ' selezionat' + (selectedItems.length > 1 ? 'i' : 'o')">
            <strong>{{selectedItems.length}}</strong> Element{{selectedItems.length > 1 ? 'i' : 'o'}} selezionati
          </label>
          <label *ngIf="selectedItems.length === 0 && noElementsLabel" aria-live="assertive" aria-atomic="true" [attr.aria-label]="'Nessun elemento selezionato'">
            Nessun elemento selezionato
          </label>
        </span>
        <span style="max-height: 200px; overflow: auto;">
          <span class="selected-item" tabindex="0" *ngFor="let item of selectedItems;trackBy: trackByFn;let k = index" [hidden]="k > _settings.itemsShowLimit-1">
            {{item.text}} <span *ngIf="!!item.categoriaText" class="item-categoria-grouped">{{item.categoriaText}}</span>
            <a class="closing-tag-btn" tabindex="1" role="button" [attr.aria-label]="'Elimina' + item.text" style="padding-top:2px;padding-left:2px;color:white" (keydown)="onItemDeleteKeydown($event,item)" (click)="onItemClick($event,item)">
              <span class="glyphicon glyphicon-remove"></span>
            </a>
          </span>
          <!-- <span style="float:right !important;padding-right:4px">
            <span style="padding-right: 6px;" *ngIf="itemShowRemaining()>0">+{{itemShowRemaining()}}</span>
            <span [ngClass]="_settings.defaultOpen ? 'dropdown-up' : 'dropdown-down'"></span>
          </span> -->
        </span>
      </div>
    </div>
  </div>
</ng-template>
